import React from "react";

const ScreenPagePart = ({ children }) => {

    return(
        <div className="app signupPage">
      <div className="screenPageBody">
        <div className="subSection heavyLogoSection blueInner pc">
          <div className="inner">
            <div className="heavyLogo">CRM & Logo</div>
            <div className="descriptionText">
              <p>
                Mattis morbi augue molestie sit non dui mattis accumsan lectus
                tempus sed ipsum orci, in malesuada et. Nulla quam, et mauris in
                in risus sit hac accumsan ultricies. Vestibulum amet,
                consectetur dolor
              </p>
            </div>
          </div>
        </div>
        <div className="subSection authSection">
          {children}
        </div>
      </div>
    </div>
    )
}

export default ScreenPagePart;